import { createContext, use } from 'react';

import { FeatureSubscriptionsEditing } from 'features/feature-subscriptions/hooks/feature-subscriptions-editing';

const FeatureSubscriptionsEditingProviderContext = createContext<FeatureSubscriptionsEditing | null>(null);

export const useFeatureSubscriptionsEditingContext = (): FeatureSubscriptionsEditing => {
  const context = use(FeatureSubscriptionsEditingProviderContext);
  if (context === null) {
    throw new Error('useFeatureSubscriptionsEditingContext must be used within a FeatureSubscriptionsEditingProvider');
  }
  return context;
};

export default FeatureSubscriptionsEditingProviderContext;
